/* North America: UK product addresses 404 there, so send visitors to the US version. */
(function () {
  try {
    var c = (window.Shopify && window.Shopify.country) || '';
    var m = location.pathname.match(/^(\/[a-z]{2}(?:-[a-z]{2})?)?\/products\/([^\/?#]+)\/?$/i);
    var is404 = document.documentElement.innerHTML.indexOf('"pageType":"404"') !== -1 || !!(document.body && document.body.classList.contains('template-404'));
    if (!m || !is404 || /-us$/i.test(m[2])) return;
    if (['US','CA','PR','VI','GU','AS','MP'].indexOf(c) === -1) return;
    var key = 'mtb_us_redirect_' + m[2];
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
    location.replace((m[1] || '') + '/products/' + m[2] + '-us' + location.search);
  } catch (e) {}
})();
// Metabolics cart drawer
// A visual replica of the UpCart drawer, powered by our own pairing and
// Subscribe & Save logic. No third-party dependencies.
(function () {
  'use strict';

  var CFG = {
    recommendationsUrl: '',
    freeShippingThreshold: 5000,
    logoUrl: null,
    shopName: '',
    currency: 'GBP',
    subscriptionDiscountLabel: 'Save 15%',
    maxRecommendations: 6,
  };
  try {
    var el = document.getElementById('metabolics-cart-drawer-config');
    if (el) Object.assign(CFG, JSON.parse(el.textContent));
  } catch (e) { /* defaults */ }

  // Same-origin fallback staples, used only when the recommendations service
  // cannot be reached (content blockers, dropped mobile connections).
  var LOCAL_STAPLES = [
    'magnesium-bisglycinate-capsules',
    'omega-3',
    'vitamin-d3-and-k2-2500-iu',
    'lactobacillus-acidophilus-pot-of-90-capsules',
    'b-complex-capsules',
    'vitamin-c-pot-of-90-capsules',
  ];
  var LOCAL_STAPLE_HOOKS = {
    'magnesium-bisglycinate-capsules': 'A gentle, well-absorbed magnesium to support normal muscle function and help reduce tiredness.',
    'omega-3': 'EPA and DHA to support normal heart, brain and vision function.',
    'vitamin-d3-and-k2-2500-iu': 'Vitamin D3 with K2 to support the maintenance of normal bones and immune function.',
    'lactobacillus-acidophilus-pot-of-90-capsules': 'A straightforward live culture formulation, popular alongside daily routines.',
    'b-complex-capsules': 'Full-spectrum B vitamins to support normal energy-yielding metabolism.',
    'vitamin-c-pot-of-90-capsules': 'Vitamin C to support normal immune system function.',
  };


  var state = { cart: null, recs: [], recsKey: '', open: false, busy: false, loadingRecs: false, recsFailed: false, codeOpen: false, codeMsg: '' };
  var productCache = {};
  var upgradePlans = {}; // key -> [{id, name, pct, price}]
  var CHECKOUT_TEST_KEY = 'mcd_checkout_colour_v1';
  var TRACK_URL = window.__CLARA_TRACK_URL || 'https://hscadcshumjwpbykirdu.supabase.co/functions/v1/clara-public-track';
  var checkoutVariant = checkoutTestVariant();
  var checkoutViewTracked = false;

  function checkoutTestVariant() {
    try {
      var saved = localStorage.getItem(CHECKOUT_TEST_KEY);
      if (saved === 'bronze' || saved === 'navy') return saved;
      var assigned = Math.random() < 0.5 ? 'bronze' : 'navy';
      localStorage.setItem(CHECKOUT_TEST_KEY, assigned);
      return assigned;
    } catch (e) {
      return Math.random() < 0.5 ? 'bronze' : 'navy';
    }
  }

  function trackingAnonId() {
    try {
      var id = localStorage.getItem('clara_anon_id') || localStorage.getItem('clara_public_anon_id');
      if (!id) {
        id = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0;
          return (c === 'x' ? r : (r & 3 | 8)).toString(16);
        });
      }
      localStorage.setItem('clara_anon_id', id);
      localStorage.setItem('clara_public_anon_id', id);
      return id;
    } catch (e) { return null; }
  }

  function trackCheckoutTest(eventType) {
    try {
      var anon = trackingAnonId();
      if (!anon) return;
      var payload = { surface: 'cart_drawer', experiment: 'checkout_colour_v1', variant: checkoutVariant };
      var body = JSON.stringify({ event_type: eventType, anon_id: anon, payload: payload, referrer: document.referrer || null });
      if (navigator.sendBeacon) navigator.sendBeacon(TRACK_URL, new Blob([body], { type: 'application/json' }));
      else fetch(TRACK_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true });
      if (typeof window.gtag === 'function') window.gtag('event', eventType, payload);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventType }, payload));
    } catch (e) { /* analytics must never interrupt checkout */ }
  }

  /* ---------- account-aware pricing (window.__mbSub inject) ---------- */

  // Discount actually applied to the basket right now (auto-applied code or
  // automatic discount, e.g. CUSTOMER10). Used when no tag inject is present.
  // Only the account tiers we actually issue. Anything else (promo codes,
  // bundles, mixed-code baskets) is not account pricing and is ignored here.
  var ACCOUNT_TIERS = [10, 15, 20, 25, 30];

  function snapToTier(pct) {
    for (var t = 0; t < ACCOUNT_TIERS.length; t++) {
      if (Math.abs(pct - ACCOUNT_TIERS[t]) <= 1) return ACCOUNT_TIERS[t];
    }
    return 0;
  }

  function cartAppliedPct() {
    var items = (state.cart && state.cart.items) || [];
    var tier = 0;
    for (var n = 0; n < items.length; n++) {
      var i = items[n];
      if (i.selling_plan_allocation) continue; // subscription pricing handled separately
      var orig = Number(i.original_line_price || 0);
      var fin = Number(i.final_line_price || 0);
      if (!orig) continue;
      if (fin >= orig) return 0; // an undiscounted line means this isn't account pricing
      var linePct = snapToTier((1 - fin / orig) * 100);
      if (!linePct) return 0;           // odd percentage -> not one of our tiers
      if (tier && linePct !== tier) return 0; // mixed rates -> don't guess
      tier = linePct;
    }
    return tier;
  }

  function subConfig() {
    var c = window.__mbSub || {};
    var isPract = !!c.isPractitioner;
    var custOtp = Number(c.customerOtpPct || 0) || 0;
    if (!isPract && !custOtp) custOtp = cartAppliedPct();
    var custSub = Number(c.customerSubPct || 0) || 0;
    var practSub = c.practitionerSubPct || 30;
    var practOtp = c.practitionerOtpPct || 25;
    var stdSub = c.standardSubPct || 15;
    return {
      isPract: isPract,
      practSubPct: practSub,
      practOtpPct: practOtp,
      stdSubPct: stdSub,
      custOtpPct: custOtp,
      custSubPct: custSub,
      // Effective account rates (practitioner tag wins, then customer discount tag).
      otpPct: isPract ? practOtp : custOtp,
      subPct: isPract ? practSub : Math.max(stdSub, custSub || custOtp),
      hasAccountPricing: isPract || custOtp > 0 || custSub > 0,
    };
  }
  function subPct() { return subConfig().subPct; }
  function otpPct() { return subConfig().otpPct; }

  /* ---------- helpers ---------- */

  function money(cents) {
    var n = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: CFG.currency || 'GBP' }).format(n);
    } catch (e) { return '£' + n.toFixed(2); }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }


  /* ---------- error reporting ---------- */

  var ERROR_URL = 'https://hscadcshumjwpbykirdu.supabase.co/functions/v1/cart-drawer-error';
  var reportedKeys = {};
  var reportCount = 0;

  function reportError(stage, err, extra) {
    try {
      if (reportCount >= 8) return;               // never spam from one page view
      var message = (err && (err.message || err.toString())) || 'unknown';
      var key = stage + '|' + String(message).slice(0, 120);
      if (reportedKeys[key]) return;              // once per page view per error
      reportedKeys[key] = true;
      reportCount++;
      var statusMatch = /HTTP (\d{3})/.exec(String(message));
      var payload = {
        stage: stage,
        message: String(message).slice(0, 400),
        status: statusMatch ? Number(statusMatch[1]) : null,
        url: location.href.slice(0, 300),
        handle: (extra && extra.handle) || '',
        theme: (window.Shopify && Shopify.theme && String(Shopify.theme.id)) || '',
        ua: navigator.userAgent.slice(0, 250),
      };
      var blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
      if (navigator.sendBeacon && navigator.sendBeacon(ERROR_URL, blob)) return;
      fetch(ERROR_URL, {
        method: 'POST', mode: 'cors', credentials: 'omit', keepalive: true,
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
      }).catch(function () {});
    } catch (e) { /* reporting must never break the drawer */ }
  }

  // Uncaught errors coming from our own script.
  window.addEventListener('error', function (e) {
    if (!e || !e.filename || e.filename.indexOf('metabolics-cart-drawer') === -1) return;
    reportError('script_error', e.error || new Error(e.message || 'script error'));
  });

  function getJSON(url, opts) {
    return fetch(url, Object.assign({ credentials: 'same-origin', headers: { 'Content-Type': 'application/json' } }, opts || {}))
      .then(function (r) {
        if (!r.ok) { var err = new Error('HTTP ' + r.status + ' for ' + url); err.status = r.status; throw err; }
        return r.json();
      });
  }

  function getCart() {
    return getJSON(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js');
  }

  function getProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return getJSON('/products/' + handle + '.js').then(function (p) {
      productCache[handle] = p;
      return p;
    }).catch(function () { return null; });
  }

  function firstSellingPlan(variant) {
    var alloc = variant && variant.selling_plan_allocations && variant.selling_plan_allocations[0];
    return alloc ? { id: alloc.selling_plan_id, price: alloc.price } : null;
  }

  function cartItemHandle(item) {
    if (item.handle) return item.handle;
    if (item.product_handle) return item.product_handle;
    var match = String(item.url || '').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  // Discount chips + total for a cart line (code and automatic discounts).
  function lineDiscounts(item) {
    var map = {};
    (item.discounts || []).forEach(function (d) {
      if (!d || !d.amount) return;
      var t = d.title || 'Discount';
      if (!map[t]) map[t] = { title: t, amount: 0 };
      map[t].amount += d.amount;
    });
    var list = Object.keys(map).map(function (k) { return map[k]; });
    var total = list.reduce(function (s, d) { return s + d.amount; }, 0);
    return { list: list, total: total };
  }

  function cartDiscounts() {
    var map = {};
    ((state.cart && state.cart.items) || []).forEach(function (item) {
      lineDiscounts(item).list.forEach(function (d) {
        if (!map[d.title]) map[d.title] = 0;
        map[d.title] += d.amount;
      });
    });
    return Object.keys(map).map(function (t) { return { title: t, amount: map[t] }; });
  }

  /* ---------- discount codes ---------- */
  // Codes are applied to the basket itself (cart/update.js "discount"), so they
  // carry into checkout already applied: shoppers never need Shopify's
  // checkout code box, which can't be moved on mobile.

  // Codes on the basket, with whether Shopify accepted them. Older cart JSON
  // has no discount_codes, so fall back to code discounts named on the lines.
  function basketCodes() {
    var cart = state.cart || {};
    if (Array.isArray(cart.discount_codes)) {
      return cart.discount_codes.map(function (d) { return { code: String(d.code || ''), applicable: d.applicable !== false }; })
        .filter(function (d) { return d.code; });
    }
    return (cart.cart_level_discount_applications || []).concat(
      [].concat.apply([], (cart.items || []).map(function (i) { return i.line_level_discount_allocations || []; }))
        .map(function (a) { return a.discount_application || {}; })
    ).filter(function (a) { return a.type === 'discount_code' && (a.title || a.key); })
      .map(function (a) { return { code: String(a.title || a.key), applicable: true }; })
      .filter(function (d, i, all) { return all.map(function (x) { return x.code.toLowerCase(); }).indexOf(d.code.toLowerCase()) === i; });
  }

  function setBasketCodes(codes) {
    return getJSON('/cart/update.js', { method: 'POST', body: JSON.stringify({ discount: codes.join(',') }) })
      .then(function (cart) { return cart && cart.items ? cart : getCart(); });
  }

  function applyCode(raw) {
    var code = String(raw || '').trim();
    if (!code) { state.codeMsg = 'Enter a discount code.'; renderFooter(); return Promise.resolve(); }
    var current = basketCodes().filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
    if (current.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) {
      state.codeMsg = code.toUpperCase() + ' is already applied.'; renderFooter(); return Promise.resolve();
    }
    state.busy = true; state.codeMsg = ''; renderFooter();
    return setBasketCodes(current.concat(code)).then(function (cart) {
      state.cart = cart;
      var mine = basketCodes().filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
      if (mine && mine.applicable) {
        state.codeOpen = false;
        state.codeMsg = '';
        state.busy = false;
        render();
        return;
      }
      // Not valid for this basket: take it off again so checkout isn't left
      // holding a code that does nothing, and say so here.
      state.codeMsg = 'Sorry, ' + code.toUpperCase() + " can't be used with this basket. Some codes are for first orders, one-time purchases only, or can't be combined with other offers.";
      return setBasketCodes(current).then(function (c2) { state.cart = c2; state.busy = false; render(); });
    }).catch(function (e) {
      state.busy = false;
      state.codeMsg = "We couldn't apply that code just now. Please try again, or enter it at checkout.";
      reportError('discount_apply', e);
      renderFooter();
    });
  }

  function removeCode(code) {
    var keep = basketCodes().filter(function (d) { return d.applicable && d.code.toLowerCase() !== String(code).toLowerCase(); })
      .map(function (d) { return d.code; });
    state.busy = true; state.codeMsg = ''; renderFooter();
    return setBasketCodes(keep).then(function (cart) { state.cart = cart; state.busy = false; render(); })
      .catch(function (e) { state.busy = false; reportError('discount_remove', e); refresh(); });
  }

  function codeBlock() {
    var codes = basketCodes().filter(function (d) { return d.applicable; });
    var chips = codes.map(function (d) {
      return '<span class="mcd-code-chip">' + esc(d.code.toUpperCase()) +
        '<button type="button" data-action="code-remove" data-code="' + esc(d.code) + '" aria-label="Remove code ' + esc(d.code) + '">&#10005;</button></span>';
    }).join('');
    var msg = state.codeMsg ? '<p class="mcd-code-msg" role="alert">' + esc(state.codeMsg) + '</p>' : '';
    if (!state.codeOpen) {
      return '<div class="mcd-code">' +
        (chips ? '<div class="mcd-code-chips">' + chips + '</div>' : '') +
        '<button type="button" class="mcd-code-toggle" data-action="code-toggle">' +
          (codes.length ? 'Add another code' : 'Have a discount code?') +
        '</button>' + msg +
      '</div>';
    }
    return '<div class="mcd-code mcd-code-open">' +
      (chips ? '<div class="mcd-code-chips">' + chips + '</div>' : '') +
      '<div class="mcd-code-form">' +
        '<input class="mcd-code-input" type="text" inputmode="text" autocomplete="off" autocapitalize="characters" spellcheck="false" aria-label="Discount code" placeholder="Discount code" data-mcd-code-input>' +
        '<button type="button" class="mcd-code-apply" data-action="code-apply"' + (state.busy ? ' disabled' : '') + '>' + (state.busy ? 'Applying&hellip;' : 'Apply') + '</button>' +
      '</div>' + msg +
    '</div>';
  }

  /* ---------- markup ---------- */

  var overlay, drawer;

  var SWAP_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16" aria-hidden="true"><path d="M17 1l4 4-4 4"/><path d="M3 11V9a4 4 0 014-4h14"/><path d="M7 23l-4-4 4-4"/><path d="M21 13v2a4 4 0 01-4 4H3"/></svg>';

  function mount() {
    if (drawer) return;
    overlay = document.createElement('div');
    overlay.className = 'mcd-overlay mcd-root';
    overlay.addEventListener('mousedown', function (e) { e.preventDefault(); close(); });
    overlay.addEventListener('touchstart', function () { close(); }, { passive: true });
    overlay.addEventListener('click', close);

    drawer = document.createElement('aside');
    drawer.className = 'mcd-drawer mcd-root';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-label', 'Your basket');
    drawer.innerHTML =
      '<div class="mcd-trust">' +
        '<span class="mcd-trust-star">&#9733;</span>' +
        '100,000+ happy customers &middot; Made in Wiltshire since 1991' +
      '</div>' +
      '<div class="mcd-header">' +
        (CFG.logoUrl ? '<img src="' + esc(CFG.logoUrl) + '" alt="' + esc(CFG.shopName) + '">'
                     : '<span class="mcd-line-title">' + esc(CFG.shopName) + '</span>') +
        '<button class="mcd-close" type="button" aria-label="Close basket">&#10005;</button>' +
      '</div>' +
      '<div class="mcd-shipping" data-mcd-shipping></div>' +
      '<div class="mcd-body">' +
        '<div class="mcd-lines" data-mcd-lines></div>' +
        '<div class="mcd-recs" data-mcd-recs></div>' +
      '</div>' +
      '<div class="mcd-footer" data-mcd-footer></div>';

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    drawer.querySelector('.mcd-close').addEventListener('click', close);
    drawer.addEventListener('click', onDrawerClick);
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-mcd-code-input]')) {
        e.preventDefault();
        if (!state.busy) applyCode(e.target.value);
      }
    });
    drawer.addEventListener('change', onDrawerChange);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.open) close(); });
    // Safety net: any pointer down outside the drawer closes it.
    document.addEventListener('pointerdown', function (e) {
      if (!state.open || !drawer) return;
      if (drawer.contains(e.target)) return;
      if (e.target.closest && e.target.closest('a[href$="/cart"], a[href*="/cart?"], [data-mcd-open]')) return;
      close();
    }, true);
  }

  function renderShipping() {
    var box = drawer.querySelector('[data-mcd-shipping]');
    var total = state.cart ? state.cart.total_price : 0;
    var threshold = Number(CFG.freeShippingThreshold) || 0;
    if (!threshold) { box.innerHTML = ''; return; }
    var remaining = Math.max(threshold - total, 0);
    var pct = Math.min(100, threshold ? (total / threshold) * 100 : 0);
    box.innerHTML =
      '<p class="mcd-shipping-text">' +
        (remaining > 0
          ? "You're <strong>" + money(remaining) + '</strong> away from free shipping!'
          : 'You have unlocked <strong>free shipping</strong>!') +
      '</p>' +
      '<div class="mcd-shipping-track">' +
        '<div class="mcd-shipping-fill" style="width:' + pct.toFixed(1) + '%"></div>' +
        '<div class="mcd-shipping-marker" style="left:' + pct.toFixed(1) + '%">&#9906;</div>' +
      '</div>' +
      '<div class="mcd-shipping-label">Free Shipping</div>';
  }

  function renderLines() {
    var box = drawer.querySelector('[data-mcd-lines]');
    var items = (state.cart && state.cart.items) || [];
    if (!items.length) {
      box.innerHTML = '<div class="mcd-empty">Your basket is empty.</div>';
      return;
    }
    box.innerHTML = items.map(function (item) {
      var onSubscription = !!item.selling_plan_allocation;
      var planName = onSubscription ? item.selling_plan_allocation.selling_plan.name : '';
      var handle = cartItemHandle(item);
      var disc = lineDiscounts(item);

      // Per-line savings: subscription allocation vs RRP, or line discount.
      var strike = null, now = item.final_line_price, saveLabel = '';
      if (onSubscription && item.selling_plan_allocation &&
          item.selling_plan_allocation.compare_at_price > item.selling_plan_allocation.price) {
        strike = item.selling_plan_allocation.compare_at_price * item.quantity;
        now = item.selling_plan_allocation.price * item.quantity;
      } else if (item.original_line_price > item.final_line_price) {
        strike = item.original_line_price;
        now = item.final_line_price;
      }
      if (strike && strike > now) saveLabel = '<span class="mcd-line-save">(Save ' + money(strike - now) + ')</span>';

      var chips = disc.list.map(function (d) {
        return '<span class="mcd-disc-chip">' + esc(d.title) + '</span>';
      }).join('');
      var priceHtml =
        '<p class="mcd-line-price">' +
          (strike ? '<span class="mcd-line-rrp">' + money(strike) + '</span>' : '') +
          '<span class="mcd-line-now">' + money(now) + '</span>' + saveLabel +
        '</p>' + chips;

      // Upgrade panel (UpCart style): collapsed row, expandable frequency picker.
      var upgradeHtml = (onSubscription || !handle) ? '' :
        '<div class="mcd-upgrade" data-action="upgrade-toggle" data-handle="' + esc(handle) + '" data-variant="' + item.variant_id + '" data-key="' + esc(item.key) + '">' +
          '<span class="mcd-upgrade-label">' + SWAP_ICON + 'Upgrade to Subscribe &amp; Save</span>' +
          '<span class="mcd-upgrade-badge">Save ' + subPct() + '%</span>' +
        '</div>' +
        '<div class="mcd-upgrade-body" data-upgrade-body="' + esc(item.key) + '">' +
          '<select class="mcd-select mcd-upgrade-freq" data-action="upgrade-freq" data-key="' + esc(item.key) + '">' +
            '<option>Loading frequencies…</option>' +
          '</select>' +
          '<button class="mcd-add mcd-upgrade-confirm" type="button" data-action="upgrade-confirm" data-key="' + esc(item.key) + '">Switch to subscription</button>' +
        '</div>';

      var lineUrl = item.url || (handle ? '/products/' + handle : '');
      var imgTag = (item.featured_image && item.featured_image.url)
        ? '<img src="' + esc(item.featured_image.url) + '" alt="' + esc(item.product_title) + '">' : '';

      return '' +
        '<div class="mcd-line" data-key="' + esc(item.key) + '">' +
          '<div class="mcd-line-img">' +
            (lineUrl && imgTag
              ? '<a class="mcd-line-link" href="' + esc(lineUrl) + '">' + imgTag + '</a>'
              : imgTag) +
          '</div>' +
          '<div class="mcd-line-main">' +
            '<p class="mcd-line-title">' +
              (lineUrl
                ? '<a class="mcd-line-link" href="' + esc(lineUrl) + '">' + esc(item.product_title) + '</a>'
                : esc(item.product_title)) +
            '</p>' +
            (item.variant_title ? '<p class="mcd-line-variant">' + esc(item.variant_title) + '</p>' : '') +

            priceHtml +
            (onSubscription ? '<p class="mcd-line-sub">' + esc(planName) + '</p>' : '') +
            '<div class="mcd-qty">' +
              '<button type="button" data-action="dec" aria-label="Decrease quantity">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-action="inc" aria-label="Increase quantity">+</button>' +
            '</div>' +
            upgradeHtml +
          '</div>' +
          '<button class="mcd-remove" type="button" data-action="remove" aria-label="Remove item">&#128465;</button>' +
        '</div>';
    }).join('');
  }

  function recPriceParts(rec, selected, plan, isSub) {
    var c = subConfig();
    var base = selected.price;
    var rrp = selected.compare_at_price && selected.compare_at_price > base ? selected.compare_at_price : 0;
    var strike = null, now, label = '';

    if (c.hasAccountPricing) {
      // Account-aware inject: practitioner or tagged customer discount, same as the PDP/basket inject.
      var pct = isSub ? c.subPct : c.otpPct;
      if (pct > 0) {
        strike = base;
        now = Math.round(base * (1 - pct / 100));
        label = 'save ' + pct + '%';
      } else {
        now = base;
        if (rrp) { strike = rrp; label = 'save ' + Math.round((1 - base / rrp) * 100) + '%'; }
      }
    } else if (isSub && plan && plan.price < base) {
      now = plan.price;
      strike = base;
      label = 'save ' + Math.round((1 - plan.price / base) * 100) + '%';
    } else {
      now = base;
      if (rrp) { strike = rrp; label = 'save ' + Math.round((1 - base / rrp) * 100) + '%'; }
    }
    return {
      html: (strike ? '<span class="mcd-rec-rrp">' + money(strike) + '</span>' : '') +
            '<span class="mcd-rec-now">' + money(now) + '</span>' +
            (label ? ' <span class="mcd-rec-save">' + esc(label) + '</span>' : ''),
    };
  }

  function renderRecs() {
    var box = drawer.querySelector('[data-mcd-recs]');
    if (!state.cart || !state.cart.items.length) { box.innerHTML = ''; return; }
    if (state.loadingRecs && !state.recs.length) {
      box.innerHTML = '<div class="mcd-loading">Finding products that work with your basket...</div>';
      return;
    }
    if (!state.recs.length) {
      box.innerHTML = state.recsFailed
        ? '<div class="mcd-recs-fallback">' +
            '<p class="mcd-recs-fallback-text">We couldn&rsquo;t load suggestions just now.</p>' +
            '<a class="mcd-recs-fallback-link" href="/collections/all">Browse the full range</a>' +
          '</div>'
        : '';
      return;
    }

    var c = subConfig();
    box.innerHTML = '<h2 class="mcd-recs-title">The next step of your programme</h2>' +
      '<p class="mcd-recs-intro">Not a top-up. Every order builds on the routine you&rsquo;ve started.</p>' +
      state.recs.map(function (rec) {
        var variants = rec.product.variants.filter(function (v) { return v.available; });
        if (!variants.length) return '';
        var selected = rec.selectedVariantId
          ? variants.filter(function (v) { return v.id === rec.selectedVariantId; })[0] || variants[0]
          : variants[0];
        var plan = firstSellingPlan(selected);
        var showSub = !!plan;
        var isSub = rec.mode === 'subscription' && showSub;
        var priceHtml = recPriceParts(rec, selected, plan, isSub).html;
        var img = (rec.product.featured_image || (rec.product.images && rec.product.images[0]) || rec.imageUrl || '');
        var otpLabel = '<span class="mcd-mode-title">One-time</span>' +
          (c.otpPct > 0 ? '<span class="mcd-mode-saving">Save ' + c.otpPct + '%</span>' : '<span class="mcd-mode-saving">Single purchase</span>');
        var subLabel = '<span class="mcd-mode-title">Subscribe &amp; Save</span>' +
          '<span class="mcd-mode-saving">Save ' + subPct() + '%</span>';
        var recUrl = rec.product.url || ('/products/' + rec.handle);
        var recImg = img ? '<img src="' + esc(img) + '" alt="' + esc(rec.product.title) + '">' : '';
        return '' +
          '<div class="mcd-rec" data-handle="' + esc(rec.handle) + '">' +
            '<div class="mcd-rec-img">' + (recImg ? '<a class="mcd-line-link" href="' + esc(recUrl) + '">' + recImg + '</a>' : '') + '</div>' +
            '<div class="mcd-rec-main">' +
              '<p class="mcd-rec-title"><a class="mcd-line-link" href="' + esc(recUrl) + '">' + esc(rec.product.title) + '</a></p>' +
              (rec.hook ? '<p class="mcd-rec-hook">' + esc(rec.hook) + '</p>' : '') +

              '<p class="mcd-rec-price">' + priceHtml + '</p>' +
              (variants.length > 1
                ? '<label class="mcd-variant-field"><span class="mcd-variant-label">Choose pack size</span><select class="mcd-select" data-action="variant" aria-label="Choose pack size">' + variants.map(function (v) {
                    var optPrice = c.otpPct > 0 ? Math.round(v.price * (1 - c.otpPct / 100)) : v.price;
                    return '<option value="' + v.id + '"' + (v.id === selected.id ? ' selected' : '') + '>' +
                      esc(v.title) + ' &mdash; ' + money(optPrice) + '</option>';
                  }).join('') + '</select></label>'
                : '') +
              (showSub
                ? '<div class="mcd-toggle">' +
                    '<button type="button" data-action="mode" data-mode="onetime" class="' + (isSub ? '' : 'mcd-active') + '">' + otpLabel + '</button>' +
                    '<button type="button" data-action="mode" data-mode="subscription" class="' + (isSub ? 'mcd-active' : '') + '">' + subLabel + '</button>' +
                  '</div>'
                : '') +
              '<button class="mcd-add" type="button" data-action="add">Add</button>' +
            '</div>' +
          '</div>';
      }).join('');
  }

  function renderFooter() {
    var box = drawer.querySelector('[data-mcd-footer]');
    if (!state.cart || !state.cart.items.length) { box.innerHTML = ''; return; }
    var discs = cartDiscounts();
    var discTotal = discs.reduce(function (s, d) { return s + d.amount; }, 0);
    var discRow = discTotal > 0
      ? '<div class="mcd-disc-row"><span class="mcd-disc-row-label">Discounts</span>' +
        '<span class="mcd-disc-row-amt">&minus;' + money(discTotal) + '</span></div>'
      : '';
    box.innerHTML =
      codeBlock() +
      discRow +
      '<button class="mcd-checkout mcd-checkout-' + checkoutVariant + '" type="button" data-action="checkout" data-test-variant="' + checkoutVariant + '"' + (state.busy ? ' disabled' : '') + '>' +
        'Checkout &bull; ' + money(state.cart.total_price) +
      '</button>' +
      trustBlock();
    if (state.open && !checkoutViewTracked) {
      checkoutViewTracked = true;
      trackCheckoutTest('cart_checkout_button_view');
    }
  }

  /* ---------- trust strip under checkout ---------- */

  function payBadge(kind) {
    var w = 38, h = 24;
    var inner = '';
    if (kind === 'visa') {
      inner = '<svg viewBox="0 0 48 16" width="26" height="10"><text x="24" y="13" text-anchor="middle" font-family="Arial,Helvetica,sans-serif" font-size="13" font-style="italic" font-weight="bold" fill="#1a1f71">VISA</text></svg>';
    } else if (kind === 'mastercard') {
      inner = '<svg viewBox="0 0 32 20" width="30" height="14"><circle cx="12" cy="10" r="8" fill="#eb001b"/><circle cx="20" cy="10" r="8" fill="#f79e1b" fill-opacity="0.9"/></svg>';
    } else if (kind === 'paypal') {
      inner = '<svg viewBox="0 0 60 16" width="34" height="10"><text x="2" y="12.5" font-family="Verdana,Arial,sans-serif" font-size="11" font-weight="bold" font-style="italic" fill="#003087">Pay<tspan fill="#009cde">Pal</tspan></text></svg>';
    } else if (kind === 'applepay') {
      inner = '<svg viewBox="0 0 44 18" width="30" height="12"><g transform="translate(0,1) scale(0.031)"><path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" fill="#000"/></g><text x="17" y="14" font-family="Arial,sans-serif" font-size="12" font-weight="600" fill="#000">Pay</text></svg>';
    } else if (kind === 'googlepay') {
      inner = '<svg viewBox="0 0 46 18" width="32" height="12"><text x="2" y="14" font-family="Arial,sans-serif" font-size="13" font-weight="500" fill="#5f6368">G Pay</text></svg>';
    } else if (kind === 'shoppay') {
      inner = '<svg viewBox="0 0 40 18" width="30" height="12"><text x="20" y="13.5" text-anchor="middle" font-family="Arial,sans-serif" font-size="12" font-weight="bold" fill="#fff">shop</text></svg>';
    }
    return '<span class="mcd-pay mcd-pay-' + kind + '">' + inner + '</span>';
  }

  function trustBlock() {
    return '<div class="mcd-perks">' +
        '<span class="mcd-perk"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="5" width="14" height="12" rx="1"/><path d="M15 9h4l3 3v5h-7"/><circle cx="6" cy="18.5" r="1.8"/><circle cx="18" cy="18.5" r="1.8"/></svg>Free UK delivery over &pound;50</span>' +
        '<span class="mcd-perk"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 0 1 15.5-6.2L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-15.5 6.2L3 16"/><path d="M3 21v-5h5"/></svg>30 day easy returns</span>' +
      '</div>' +
      '<div class="mcd-pay-row">' +
        payBadge('applepay') + payBadge('googlepay') + payBadge('mastercard') +
        payBadge('paypal') + payBadge('shoppay') + payBadge('visa') +
      '</div>';
  }

  function render() {
    mount();
    renderShipping();
    renderLines();
    renderRecs();
    renderFooter();
  }

  /* ---------- upgrade panel frequencies ---------- */

  function loadUpgradePlans(key, handle, variantId) {
    var body = drawer.querySelector('[data-upgrade-body="' + key + '"]');
    if (!body) return Promise.resolve();
    var sel = body.querySelector('[data-action="upgrade-freq"]');
    return getProduct(handle).then(function (p) {
      if (!p || !sel) return;
      var variant = p.variants.filter(function (v) { return v.id === Number(variantId); })[0] || p.variants[0];
      var groups = p.selling_plan_groups || [];
      var plans = [];
      groups.forEach(function (g) {
        (g.selling_plans || []).forEach(function (sp) {
          var alloc = (variant.selling_plan_allocations || []).filter(function (a) { return a.selling_plan_id === sp.id; })[0];
          if (!alloc) return;
          var pct = alloc.compare_at_price && alloc.price < alloc.compare_at_price
            ? Math.round((1 - alloc.price / alloc.compare_at_price) * 100)
            : (alloc.price < variant.price ? Math.round((1 - alloc.price / variant.price) * 100) : 0);
          plans.push({ id: sp.id, name: sp.name, pct: pct, price: alloc.price });
        });
      });
      upgradePlans[key] = plans;
      if (!plans.length) {
        sel.innerHTML = '<option>No subscription options available</option>';
        var confirm = body.querySelector('[data-action="upgrade-confirm"]');
        if (confirm) confirm.disabled = true;
        return;
      }
      sel.innerHTML = plans.map(function (pl) {
        return '<option value="' + pl.id + '">' + esc(pl.name) + (pl.pct ? ' (save ' + pl.pct + '%)' : '') + '</option>';
      }).join('');
    });
  }

  /* ---------- recommendations ---------- */

  function loadRecs() {
    if (!CFG.recommendationsUrl || !state.cart || !state.cart.items.length) { state.recs = []; return Promise.resolve(); }
    var handles = state.cart.items.map(function (i) { return i.handle; });
    var key = handles.slice().sort().join('|');
    if (key === state.recsKey && state.recs.length) return Promise.resolve();
    state.recsKey = key;
    state.loadingRecs = true;
    state.recsFailed = false;
    renderRecs();

    // Don't let a slow function leave the panel spinning.
    function attempt() {
      var timeout = new Promise(function (_, reject) {
        setTimeout(function () { reject(new Error('timeout')); }, 8000);
      });
      return Promise.race([getJSON(CFG.recommendationsUrl, {
        method: 'POST',
        credentials: 'omit',
        body: JSON.stringify({ handles: handles, limit: CFG.maxRecommendations, region: 'uk' }),
      }), timeout]);
    }

    function hydrate(handleList, hooks) {
      return Promise.all(handleList.map(function (h) {
        return getProduct(h).then(function (p) {
          if (!p || !p.available) return null;
          return {
            handle: h,
            hook: (hooks && hooks[h]) || null,
            imageUrl: null,
            product: p,
            mode: 'onetime',
            selectedVariantId: null,
          };
        }).catch(function () { return null; });
      }));
    }

    // Safari and privacy-blocked browsers sometimes drop the cross-origin call
    // entirely ("Load failed"). Fall back to same-origin product data so the
    // panel still shows something useful.
    function localFallback() {
      var staples = [];
      for (var i = 0; i < LOCAL_STAPLES.length; i++) {
        if (handles.indexOf(LOCAL_STAPLES[i]) === -1) staples.push(LOCAL_STAPLES[i]);
      }
      return hydrate(staples.slice(0, CFG.maxRecommendations || 4), LOCAL_STAPLE_HOOKS);
    }

    // One quiet retry first: mobile Safari drops the occasional fetch.
    return attempt().catch(function () {
      return new Promise(function (resolve) { setTimeout(resolve, 700); }).then(attempt);
    }).then(function (data) {
      if (!data || !data.recommendations) throw new Error('bad payload');
      return hydrate(
        data.recommendations.map(function (r) { return r.handle; }),
        data.recommendations.reduce(function (acc, r) { acc[r.handle] = r.hook; return acc; }, {})
      );
    }).catch(function (err) {
      console.warn('[mcd] recommendations failed, using local staples', err);
      reportError('recommendations', err);
      state.recsKey = '';   // allow a fresh attempt on the next open
      return localFallback();
    }).then(function (list) {
      state.recs = (list || []).filter(Boolean);
      state.recsFailed = !state.recs.length;
      state.loadingRecs = false;
      renderRecs();
    }).catch(function () {
      state.recs = [];
      state.recsKey = '';
      state.recsFailed = true;
      state.loadingRecs = false;
      renderRecs();
    });
  }


  /* ---------- cart mutations ---------- */

  function refresh(reloadRecs) {
    return getCart().then(function (cart) {
      state.cart = cart;
      render();
      if (reloadRecs !== false) loadRecs();
      document.dispatchEvent(new CustomEvent('mcd:cart-updated', { detail: cart }));
      return cart;
    }).catch(function (e) {
      reportError('cart_fetch', e);
      throw e;
    });
  }

  function changeLine(key, quantity, sellingPlan) {
    if (state.busy) return Promise.resolve(); // ignore double-clicks while a change is in flight
    var oldItem = ((state.cart && state.cart.items) || []).filter(function (i) { return i.key === key; })[0];
    function post(id) {
      var payload = { id: id, quantity: quantity };
      if (sellingPlan) payload.selling_plan = sellingPlan;
      return getJSON('/cart/change.js', { method: 'POST', body: JSON.stringify(payload) });
    }
    state.busy = true;
    return post(key)
      .catch(function (e) {
        // 400 usually means the line key went stale (basket changed in another tab or by an app).
        // Re-read the basket and retry once against the matching line.
        if (!e || e.status !== 400 || !oldItem) throw e;
        return getCart().then(function (cart) {
          var match = (cart.items || []).filter(function (i) {
            return i.variant_id === oldItem.variant_id &&
              ((i.selling_plan_allocation && i.selling_plan_allocation.selling_plan.id) || null) ===
              ((oldItem.selling_plan_allocation && oldItem.selling_plan_allocation.selling_plan.id) || null);
          })[0];
          if (!match) { if (quantity === 0) return cart; throw e; } // already removed: nothing to do
          return post(match.key);
        });
      })
      .then(function (cart) { state.cart = cart; state.busy = false; render(); loadRecs(); })
      .catch(function (e) { state.busy = false; console.warn('[mcd] change failed', e); reportError('cart_change', e); refresh(); });
  }

  // Record upsell attribution on the cart so the order webhook can tag the order.
  function markCartAttribution(attrs) {
    try {
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs }),
      }).catch(function () {});
    } catch (e) { return Promise.resolve(); }
  }

  function appendAttr(existing, value) {
    var list = String(existing || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (list.indexOf(value) === -1) list.push(value);
    return list.slice(0, 10).join(', ');
  }

  function addVariant(variantId, sellingPlan, meta) {
    var item = { id: variantId, quantity: 1 };
    if (sellingPlan) item.selling_plan = sellingPlan;
    if (meta && meta.sku) item.properties = { _upsell: 'cart-drawer', _upsell_sku: meta.sku };
    state.busy = true;
    return getJSON('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: [item] }) })
      .then(function () {
        if (meta && meta.sku) {
          var current = (state.cart && state.cart.attributes) || {};
          return markCartAttribution({
            Upsell: 'cart_drawer',
            'Upsell SKU': appendAttr(current['Upsell SKU'], meta.sku),
            'Upsell product': meta.title || '',
          });
        }
      })
      .then(function () { state.busy = false; return refresh(); })
      .catch(function (e) { state.busy = false; console.warn('[mcd] add failed', e); reportError('cart_add', e); });
  }


  /* ---------- events ---------- */

  function onDrawerChange(e) {
    var sel = e.target.closest('[data-action="variant"]');
    if (!sel) return;
    var card = sel.closest('.mcd-rec');
    var rec = state.recs.filter(function (r) { return r.handle === card.dataset.handle; })[0];
    if (!rec) return;
    rec.selectedVariantId = Number(sel.value);
    renderRecs();
  }

  function onDrawerClick(e) {
    var btn = e.target.closest('[data-action]');
    if (!btn || state.busy) return;
    var action = btn.dataset.action;

    if (action === 'code-toggle') {
      state.codeOpen = true;
      state.codeMsg = '';
      renderFooter();
      var input = drawer.querySelector('[data-mcd-code-input]');
      if (input) input.focus();
      return;
    }
    if (action === 'code-apply') {
      var field = drawer.querySelector('[data-mcd-code-input]');
      return applyCode(field ? field.value : '');
    }
    if (action === 'code-remove') return removeCode(btn.dataset.code || '');

    var line = btn.closest('.mcd-line');
    if (line) {
      var key = line.dataset.key;
      var item = state.cart.items.filter(function (i) { return i.key === key; })[0];
      if (!item) return;
      if (action === 'inc') return changeLine(key, item.quantity + 1);
      if (action === 'dec') return changeLine(key, Math.max(item.quantity - 1, 0));
      if (action === 'remove') return changeLine(key, 0);
      if (action === 'upgrade-toggle') {
        var body = drawer.querySelector('[data-upgrade-body="' + key + '"]');
        if (!body) return;
        var isOpen = body.classList.toggle('mcd-open');
        if (isOpen && !upgradePlans[key]) loadUpgradePlans(key, btn.dataset.handle, btn.dataset.variant);
        return;
      }
      if (action === 'upgrade-confirm') {
        var plans = upgradePlans[key] || [];
        if (!plans.length) return;
        var sel = drawer.querySelector('[data-action="upgrade-freq"][data-key="' + key + '"]');
        var planId = sel && sel.value ? Number(sel.value) : plans[0].id;
        btn.disabled = true;
        btn.textContent = 'Switching…';
        var upSku = (item.sku || item.handle || item.product_handle || '');
        var curAttrs = (state.cart && state.cart.attributes) || {};
        markCartAttribution({
          'Sub upgrade': 'cart_drawer',
          'Sub upgrade SKU': appendAttr(curAttrs['Sub upgrade SKU'], upSku),
        });
        return changeLine(key, item.quantity, planId);

      }
    }

    var card = btn.closest('.mcd-rec');
    if (card) {
      var rec = state.recs.filter(function (r) { return r.handle === card.dataset.handle; })[0];
      if (!rec) return;
      if (action === 'mode') { rec.mode = btn.dataset.mode; return renderRecs(); }
      if (action === 'add') {
        var variants = rec.product.variants.filter(function (v) { return v.available; });
        var chosen = rec.selectedVariantId
          ? variants.filter(function (v) { return v.id === rec.selectedVariantId; })[0] || variants[0]
          : variants[0];
        var plan = rec.mode === 'subscription' ? firstSellingPlan(chosen) : null;
        btn.disabled = true;
        return addVariant(chosen.id, plan && plan.id, { sku: chosen.sku || rec.handle, title: rec.product.title });

      }
    }

    if (action === 'checkout') {
      trackCheckoutTest('cart_checkout_button_click');
      window.location.href = '/checkout';
    }
  }

  function open() {
    mount();
    state.open = true;
    checkoutViewTracked = false;
    document.documentElement.classList.add('mcd-cart-open');
    overlay.classList.add('mcd-open');
    drawer.classList.add('mcd-open');
    document.documentElement.style.overflow = 'hidden';
    refresh();
  }

  function close() {
    if (!drawer) return;
    state.open = false;
    document.documentElement.classList.remove('mcd-cart-open');
    overlay.classList.remove('mcd-open');
    drawer.classList.remove('mcd-open');
    document.documentElement.style.overflow = '';
    // Any product form left mid-spin by our interception goes back to normal.
    Array.prototype.forEach.call(
      document.querySelectorAll('form[action*="/cart/add"]'),
      function (f) { clearFormLoading(f); }
    );
  }


  /* ---------- theme interception ---------- */

  // Cart links and icons open the drawer instead of navigating.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href$="/cart"], a[href*="/cart?"], [data-mcd-open]');
    if (!link) return;
    e.preventDefault();
    open();
  }, true);

  // Reset whatever loading state the theme put on the add-to-cart button, since we
  // intercepted the submit and the theme never gets its own response back.
  function clearFormLoading(form) {
    try {
      var scope = form.closest('product-form, .product-form, .shopify-product-form') || form;
      var nodes = scope.querySelectorAll(
        'button[type="submit"], .product-form__submit, .loading-overlay__spinner, .loading__spinner, .loading-overlay'
      );
      Array.prototype.forEach.call(nodes, function (el) {
        el.classList.remove('loading');
        if (el.tagName === 'BUTTON') {
          el.removeAttribute('aria-disabled');
          el.removeAttribute('disabled');
          el.classList.remove('is-loading', 'btn--loading');
        } else {
          el.classList.add('hidden');
          el.setAttribute('hidden', '');
        }
      });
      scope.classList.remove('loading', 'is-loading');
    } catch (err) {}
  }

  // Theme add-to-cart forms post through us so the drawer opens with the new line.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    // Stop the theme's own product-form handler adding the same line a second time.
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (form.dataset.mcdSubmitting === '1') return;
    form.dataset.mcdSubmitting = '1';
    var done = function () {
      form.dataset.mcdSubmitting = '';
      state.busy = false;
      clearFormLoading(form);
    };
    var data = new FormData(form);
    state.busy = true;
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', body: data })
      .then(function () { done(); open(); })
      .catch(function (err) { reportError('cart_add', err); done(); form.submit(); });
    // Belt and braces: some themes set the spinner after submit fires.
    setTimeout(function () { clearFormLoading(form); }, 400);
  }, true);



  // Any other script adding to the cart still pops the drawer.
  // Some browsers/extensions/apps lock window.fetch as read-only. That must never
  // stop the drawer mounting, so the hook is optional and fails silently.
  try {
    var nativeFetch = window.fetch;
    var hooked = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var result = nativeFetch.apply(this, arguments);
      if (url.indexOf('/cart/add') !== -1) {
        result.then(function (r) { if (r && r.ok) setTimeout(open, 60); }).catch(function () {});
      }
      return result;
    };
    var desc = Object.getOwnPropertyDescriptor(window, 'fetch');
    if (!desc || desc.writable || desc.set || desc.configurable) {
      try { window.fetch = hooked; } catch (e1) {
        if (desc && desc.configurable) Object.defineProperty(window, 'fetch', { value: hooked, writable: true, configurable: true });
      }
    }
  } catch (e) { /* fetch locked: form-submit hook above still opens the drawer */ }

  window.MetabolicsCartDrawer = { open: open, close: close, refresh: refresh };

  if (document.readyState !== 'loading') mount();
  else document.addEventListener('DOMContentLoaded', mount);
})();
